import { createRoot } from "react-dom/client";
import { enableMapSet } from "immer";
import "./index.css";
import App from "./App.tsx";

// Required for Zustand + Immer when store state contains Map/Set (e.g. fileStore.uploads)
enableMapSet();

createRoot(document.getElementById("root")!).render(<App />);
